import {Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {AnswerDisplay, AnswerDisplayKind} from './answer-display.utils';

@Component({
  selector: 'app-suggestion-answer-display',
  imports: [TranslocoPipe, AppNumberPipe],
  templateUrl: './suggestion-answer-display.component.html',
})
export class SuggestionAnswerDisplayComponent {
  protected readonly AnswerDisplayKind = AnswerDisplayKind;

  readonly display = input.required<AnswerDisplay | null>();
  readonly emptyKey = input('provider.templates.suggestions.review.noValue');
  readonly testId = input.required<string>();
}
